import { render, staticRenderFns } from "./VoceGlossario.vue?vue&type=template&id=addf868c&scoped=true&"
import script from "./VoceGlossario.vue?vue&type=script&lang=js&"
export * from "./VoceGlossario.vue?vue&type=script&lang=js&"
import style0 from "./VoceGlossario.vue?vue&type=style&index=0&id=addf868c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addf868c",
  null
  
)

export default component.exports